/**
 * Created by Roman T on 1/29/2018.
 */
var DetailEligibilityDecisionController = (function () {
    function DetailEligibilityDecisionController(topic, $state, $stateParams, DTS, socket, $scope, env, Dialog) {
        var _this = this;
        this.topic = topic;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.DTS = DTS;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.Dialog = Dialog;
        this.comp = 'customerDesignation';
        this.desArray = ['IBM-Led', 'BP-Led', 'Co-Led', 'Unknown', 'Unassigned'];
        this.sectionHeader = 'Customer Designation';
        this.isResetting = false;
        this.showOverride = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            _this.isResetting = false;
            _this.setOverrideStatus();
        });
    }
    DetailEligibilityDecisionController.prototype.setOverrideStatus = function () {
        // If user is not an approver or reader...
        if (!this.env.user.access.approver && !this.env.user.access.reader) {
            if (this.topic.topic.status.status_no === 3 &&
                [3, 4, 23, 28, 29, 32, 33].indexOf(this.topic.topic.status.sub_status_no) < 0 &&
                angular.isDefined(this.topic.topic.goe.picked) &&
                this.topic.topic.goe.picked !== '') {
                //this.topic.topic.customerDesignation) {
                this.showOverride = true; // If in eligibility status...show it
            }
            else if (this.topic.topic.status.status_no === 4 && !this.topic.areCalcsStarted() && this.env.user.access.systemAdmin) {
                this.showOverride = true; // If in validation and pre-calcs and system admin, show it
            }
            else {
                this.showOverride = false;
            }
        }
        else {
            this.showOverride = false;
        }
        // Could be a scenario where the server says this object is not editable, but a change to another component such
        // as GE Decision or find cmr will mean this component now needs to be editable... the 10k does not refresh
        // the editable components on a partial update, so need to hack it here
        if (this.showOverride) {
            this.topic.editableComponents.customerDesignation = { editable: true, editMode: false, socket: '' };
        }
        else {
            this.topic.editableComponents.customerDesignation = { editable: false, editMode: false, socket: 'Not Editable' };
        }
    };
    DetailEligibilityDecisionController.prototype.$onInit = function () {
        this.setOverrideStatus();
    };
    DetailEligibilityDecisionController.prototype.resetDecision = function (event) {
        var _this = this;
        // Prepare data to be saved
        var cdFlagArray = ['IBM-Led', 'BP-Led', 'Co-Led', 'Unassigned'];
        var currentFlag = this.topic.topic.customerDesignation ? this.topic.topic.customerDesignation : 'Unknown';
        var flagItems = {
            cdFlags: cdFlagArray,
            cdFlag: currentFlag,
            original: currentFlag,
            message: 'Please confirm the designation should be overridden:',
            okMessage: 'OK',
            cancelMessage: 'Cancel',
            dialogName: 'Designation Override',
            addCancel: false
        };
        //flagItems.cdFlags.splice(cdFlagArray.indexOf(currentFlag), 1);
        //flagItems.cdFlag = flagItems.cdFlags[0];
        this.Dialog.updateValidForm(event, flagItems, 'detail-elig-designation-dialog.html').then(function (dResult) {
            if (dResult.confirm && dResult.comment && dResult.comment.trim() !== '' && dResult.cdFlag.trim() !== '') {
                if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                    // Prepare data to be saved
                    var updateObject = {
                        data: (_a = {},
                            _a['comments.eligibility'] = {
                                push: true,
                                data: [{
                                        comment: 'Designation changed from: ' + _this.topic.temp.customerDesignation + ' to ' + dResult.cdFlag + '; ' + dResult.comment,
                                        user: _this.env.user.email
                                    }]
                            },
                            _a.customerDesignation = {
                                add: true,
                                data: dResult.cdFlag
                            },
                            _a
                        ),
                        id: _this.topic.topic._id,
                        type: ['comments', 'customerDesignation']
                    };
                    _this.topic.updateServerTopic('couchUpdate', updateObject, true); // Send it to be saved
                    _this.isResetting = true;
                }
            }
            var _a;
        });
    };
    DetailEligibilityDecisionController.$inject = ['topic', '$state', '$stateParams', 'DTS', 'socket', '$scope', 'env', 'Dialog'];
    return DetailEligibilityDecisionController;
}());
var DetailEligibilityDecisionComponent = (function () {
    function DetailEligibilityDecisionComponent() {
        this.templateUrl = 'detail-eligibility-designation.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligibilityDecisionController;
    }
    return DetailEligibilityDecisionComponent;
}());
angular
    .module('application')
    .component('customerDesignation', new DetailEligibilityDecisionComponent());

//# sourceMappingURL=detail.eligibility.designation.component.js.map
